module.exports = __webpack_public_path__ + "static/NightInTheWoods0-bcde7661ec89d1ef3844443b08d48e06.png";